/**
 * @desc 导出bom详情信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.basics.plmProductSku.bomExport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/bomExport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
